import { BoardType } from '../../../api/ApiTypes';
import { waitFor } from '../../../CodesThatsGottaGoSomewhereElse';
import { BoardUsageModel } from '../../account/BoardUsageModel';
import { ActiveObject, resolve } from '../../Container';
import { ToastHub } from '../../packages/toast/ToastHub';
import { PassportModel } from '../../PassportModel';
import { PopupManager } from '../../popups/PopupManager';
import { BoardInfo } from '../BoardInfo';
import { EditorOptions } from '../EditorOptions';
import { EditorSession } from '../EditorSession';
import { MyRoleInfo } from '../MyRoleInfo';
import { WidgetManager } from '../workspace/widgets/WidgetManager';
import { ReadonlyMessage } from './JoinMessage';
import { joinPopup } from './JoinPopup';

export class JoinMechanics extends ActiveObject {

    @resolve(EditorOptions) private editorOpts!: EditorOptions;
    @resolve(PassportModel) private passport!: PassportModel;
    @resolve(PopupManager) private popups!: PopupManager;
    @resolve(EditorSession) private session!: EditorSession;
    @resolve(ToastHub) private toast!: ToastHub;
    @resolve(BoardUsageModel) private boardUsage!: BoardUsageModel;
    @resolve(WidgetManager) private widgets!: WidgetManager;

    public start() {
        // This is not await so as not to block the call to start()
        this.handleAskToJoinAction().then(() => {
            this.burden(this.session.observe(MyRoleInfo, this.realizeReadonlyMessageIfApplicable));
            this.realizeReadonlyMessageIfApplicable();
        });
    }

    private realizeReadonlyMessageIfApplicable = () => {
        const { canParticipate } = this.session.get(MyRoleInfo);
        const board = this.session.get(BoardInfo);
        const overLimit = board.type === BoardType.standard && !this.boardUsage.isBoardActive(board.id);
        this.realizeReadonlyMessage(!canParticipate && !overLimit);
    };

    private realizeReadonlyMessage = (realize?: boolean) => {
        const { widgets } = this;

        widgets.delete('readonlyMessage');
        if (!realize) return;

        const container = widgets.createContainer({
            name: 'readonlyMessage',
            weight: 100,
            style: 'none',
            position: ['docked', 'top', 'stack'],
        });

        container.add(widgets.createInline({
            ui: ReadonlyMessage,
            onClose: () => widgets.delete('readonlyMessage'),
        }));

        widgets.add(container);
    };

    private handleAskToJoinAction = async () => {
        if (this.editorOpts.action !== 'join') return;
        if (this.passport.verify('bo:write')) return;
        if (!this.passport.verify('bo:knock')) return;
        const board = this.session.get(BoardInfo);
        await waitFor(1000);
        await this.popups.invoke(joinPopup(board.id));
    };
}
